import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderTitleProps } from '../../../../types/headerTitleProps'
import { PlanName } from '../PlanName'

export const FamilyTitle = (props: HeaderTitleProps) => {
  const { isFamilySelected } = usePlansContext()

  return <PlanName isSelected={isFamilySelected} {...props} />
}
